import React from 'react';
import './button.scss';
import { Icon } from './icon';

export const Button: React.FunctionComponent<{
    id?: string | number;
    label: string;
    disabled?: boolean;
    type?: 'primary' | 'secondary' | 'disabled';
    icon?: string;
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}> = ({ id, label, disabled, icon, onClick, type }) => (
    <button
        id={id ? id.toString() : undefined}
        disabled={disabled}
        className={type ?? 'primary'}
        onClick={onClick}
    >
        {icon && <Icon name={icon} />}
        {label}
    </button>
);
